import { AuthService } from '../auth';
import { fetchTargetAuthProviders } from '../auth/Service/fetchTargetAuthProviders';
import { SUBSPLASH_AUTH_PROVIDER_ID } from '../constants/identifiers';

const FALLBACK_APPKEY = 'CHURCH';

// Only intended for usage in cases where we can only imperatively
// fetch the access token (e.g. app launch flow via common module).
// In the future, when the core app is migrated to react-native,
// we will be able to access the token through Context API
// and this function will be deprecated
export default async (appKey = FALLBACK_APPKEY): Promise<string | null> => {
  const targetProviders = await fetchTargetAuthProviders(appKey);

  let accessToken: string | null = null;

  try {
    const accessTokens = await AuthService.loadCredentials({
      appKey,
      source: 'app',
      targetProviders,
    });

    accessToken = accessTokens[SUBSPLASH_AUTH_PROVIDER_ID];
  } catch (e) {}

  return accessToken;
};
